import type { FaireProductEntity } from "../../entity_types/product";

export const p_h4a9xgxvmb: FaireProductEntity = {
  token: "p_h4a9xgxvmb",
  type: "product",
  name: "Grain Free Pretzels Mini Bags Variety Pack 36ct",
  brandToken: "b_2c93zrgyn5",
  brandName: "Savor by Suzie",
  imageUrl:
    "https://cdn.faire.com/fastly/24ab8d63a1db2604afbbf362b8e95a4577e306651b8244c802eed2c4d9ea7d1c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d334686761125149d24d5166775f2908ffceda16e39f6c8bdb7e8c7b5079b7be.webp",
    "https://cdn.faire.com/fastly/2315da2674ef6fa79e742cae428d0fc523398c6c641f0862cbb1dcdfb87ad0c5.webp",
    "https://cdn.faire.com/fastly/0040377b351c6be3a2b2ed2bc1ac2a76b78af4ad28a9bb9d45e2970413bf3e9b.webp",
    "https://cdn.faire.com/fastly/2e319c5e035971f1f7d1bf0485504b6ec7131a3f5b78bd2ea09b540c8eb82a78.webp",
    "https://cdn.faire.com/fastly/3e621e3267c857cce94f0f204511f84bdb683f1fc55e4286036596f5c7ec9af7.webp",
    "https://cdn.faire.com/fastly/e4530fcce68dc7d58c46252df37d27b15aad904ca0587b5fa4b46ea05cfd9cca.webp",
  ],
  priceDollars: 1.36,
  description:
    "Grain-free, gluten-free, and Top 9 Allergen Free, these snacks are a perfect fit for health-conscious customers and those with dietary restrictions. Crunchy, bold, and satisfying, they’re made in a dedicated gluten and nut-free facility. \n36-count Variety Pack includes 12 mini bags each flavor:\n- Sea Salt \n-Garlic & Herb\n-Lil’ Bit Spicy ",
  tags: [],
  msrpDollars: 2.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:12.267Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
